import { ElementRef, EventEmitter, NgZone } from '@angular/core';
import { Post } from '../../../../models/post-overview';
import { languageId, mentionType, systemValues } from '../../../app.constants';
import { InfluencerPostService } from '../../../services/influencer-post/influencer-post.service';
import { TranslateService } from '@ngx-translate/core';
import * as Chains from 'c4s';
import * as Sentry from '@sentry/browser';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { MentionService } from '../../../services/mention/mention.service';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { ActionDetails, ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { UserService } from '../../../services/user.service';
var PostContentComponent = /** @class */ (function () {
    function PostContentComponent(influencerPostService, mentionService, translate, pdfService, userService, eventTracker, modalService, zone) {
        this.influencerPostService = influencerPostService;
        this.mentionService = mentionService;
        this.translate = translate;
        this.pdfService = pdfService;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.modalService = modalService;
        this.zone = zone;
        this.refreshMentionList = new EventEmitter();
    }
    Object.defineProperty(PostContentComponent.prototype, "newMention", {
        get: function () {
            return this._newMention;
        },
        set: function (value) {
            this._newMention = value;
        },
        enumerable: true,
        configurable: true
    });
    PostContentComponent.prototype.getVideoLink = function (post) {
        return post.isStory ? post.url : post.video;
    };
    PostContentComponent.prototype.onLoadPostImageError = function () {
        this.postContent.image = systemValues.noImagePicture;
        this.onLoadedPostImage();
    };
    PostContentComponent.prototype.onAddNewMention = function () {
        this.showAddNewMention = true;
    };
    PostContentComponent.prototype.offAddNewMention = function () {
        this.showAddNewMention = false;
    };
    PostContentComponent.prototype.onCloseRequestErrorNotice = function () {
        this.modalService.close();
    };
    PostContentComponent.prototype.saveNewMention = function (evt) {
        var _this = this;
        var value = evt.value;
        // Stop processing if no input
        if (!value) {
            return;
        }
        // Update UI immediately
        if (Array.isArray(this.postMentions)) {
            this.postMentions.push(value);
        }
        else {
            this.postMentions = [value];
        }
        this.showAddNewMention = false;
        evt.value = '';
        // Prepare input for chained requests
        var state = {
            influencerPostService: this.influencerPostService,
            mention: value,
            keywordType: mentionType.keyword,
            languages: [languageId.global],
            postData: {
                topicId: this.postContent.topicId || 14,
                industryId: 28,
                url: this.postContent.url,
                publishDate: this.postContent.publishedDate,
                relativePath: this.postContent.relativePath,
                urlHash: this.postContent.urlHash,
                influencerId: this.postContent.influencerId
            },
            eventTracker: this.eventTracker,
            postTitle: this.postContent.title,
            postUrlHash: this.postContent.urlHash,
        };
        // Run requests sequentially
        Chains(state)
            .then(this.checkPostMentionExist)
            .then(this.addNewMention)
            .then(this.approveNewMention)
            .then(this.addNewPostMentions)
            .catch(function (error) {
            console.log(error);
            var serverErrorMsg;
            // if this error is not interal server error, show specific server error message
            if (error.status !== 500 && error.error && error.error.message) {
                serverErrorMsg = error.error.message;
            }
            // Revert back to previous state on error
            var mentionIndex = _this.postMentions.findIndex(function (mention) { return mention === value; });
            _this.postMentions.splice(mentionIndex, 1);
            evt.value = value;
            _this.showAddNewMention = true;
            // Report to Sentry
            Sentry.captureException(error);
            // Show user friendly error message
            _this.handleRequestError({
                message: serverErrorMsg || _this.translate.instant('page.post_overview.mention_error')
            });
        });
    };
    PostContentComponent.prototype.handleRequestError = function (error) {
        this.requestErrorMessage = error.message;
        this.modalService.open(this.requestErrorNotice);
    };
    // Chain handlers
    // Check if a mention exists
    PostContentComponent.prototype.checkPostMentionExist = function (state, next) {
        state.influencerPostService.checkPostMentionExist(state.mention).subscribe(
        // Success
        function (data) {
            state.mention_exists = !!data.id;
            state.mention_id = data.id;
            next();
        }, 
        // Error
        function (error) {
            next(error);
        });
    };
    // Create a new mention
    PostContentComponent.prototype.addNewMention = function (state, next) {
        // Mention already exists, skip this
        if (state.mention_exists) {
            return next();
        }
        // Validate input
        if (!state.mention || !state.keywordType || !state.languages || !state.postData || !state.postData.topicId || !state.postData.industryId) {
            return next(new Error('Missing parameters for `addNewMention()`.'));
        }
        // Make API call
        state.influencerPostService.addNewMention(state.mention, state.keywordType, state.languages, state.postData.topicId, state.postData.industryId).subscribe(
        // Success
        function (data) {
            if (!data) {
                return next(new Error('An error occurred while adding a new mention, `data` was undefined.'));
            }
            // Save new mention ID to state
            state.mention_id = data.id;
            var mentionParams = {
                keyword: state.mention,
                keywordType: state.keywordType,
                languages: state.languages,
                topic_id: state.postData.topicId,
                vertical_id: state.postData.industryId,
            };
            // keep track event to Segment
            state.eventTracker.trackUserAction(UserActionType.ACTION, Page.MENTION, {
                id: data.id,
                name: data.keyword,
                type: data.keywordType && data.keywordType.name
            }, {
                action: UserActionType.CREATE,
                source: ActionSource.PAGE,
                mentionParams: mentionParams
            }, undefined, {
                type: ActivePages.POST,
                name: state.postTitle,
                id: state.postUrlHash
            });
            next();
        }, 
        // Error
        function (error) {
            next(error);
        });
    };
    // Approve a newly created mention
    PostContentComponent.prototype.approveNewMention = function (state, next) {
        // Mention had already been created, skip this
        if (state.mention_exists) {
            return next();
        }
        // Validate input
        if (!state.mention_id || !state.languages || !state.postData || !state.postData.topicId || !state.postData.industryId) {
            return next(new Error('Missing parameters for `approveNewMention()`.'));
        }
        // Make the API call
        state.influencerPostService.approveMention(state.mention_id, state.languages, state.postData.topicId, state.postData.industryId).subscribe(
        // Success
        function (data) {
            if (!data) {
                return next(new Error('An error occurred while approving a new mention, `data` was undefined.'));
            }
            next();
        }, 
        // Error
        function (error) {
            next(error);
        });
    };
    // Add mention to post
    PostContentComponent.prototype.addNewPostMentions = function (state, next) {
        // Validate input
        if (!state.mention_id || !state.postData || !state.postData.url ||
            !state.postData.publishDate || !state.postData.relativePath || !state.postData.urlHash) {
            return next(new Error('Missing parameters for `addNewPostMentions()`.'));
        }
        state.influencerPostService.addNewPostMention(state.mention_id, state.postData.url, state.postData.publishDate, state.postData.relativepath, state.postData.urlHash, state.postData.influencerId).subscribe(
        // Success
        function (data) {
            if (!data) {
                return next(new Error('An error occurred while adding a mention to a post, `data` was undefined.'));
            }
            // track event to Segment
            state.eventTracker.trackUserAction(UserActionType.ACTION, Page.POST, {
                id: state.postUrlHash,
                name: state.postTitle,
                type: TargetType.POST
            }, {
                action: UserActionType.UPDATE,
                actionDetails: ActionDetails.ADDED_MENTION,
                source: ActionSource.PAGE,
                mention_id: state.mention_id,
                mention: state.mention,
                keywordType: state.keywordType
            }, undefined, {
                type: ActivePages.POST,
                name: state.postTitle,
                id: state.postUrlHash
            });
            next();
        }, 
        // Error
        function (error) {
            next(error);
        });
    };
    PostContentComponent.prototype.onLoadedPostImage = function () {
        this.pdfService.updateNumberImageLoaded(PostContentComponent.COMPONENT_NAME);
    };
    PostContentComponent.prototype.onHoverPostImage = function () {
        var _this = this;
        if (!this.postContent.isVideo) {
            return;
        }
        if (this.storyPreviewPopup) {
            this.zone.runOutsideAngular(function () {
                _this.calculateStoryPreviewPosition(window.innerWidth, window.innerHeight);
                $('.overlay, .overlay-back').fadeIn(300);
                document.body.classList.add('no-scroll');
            });
        }
    };
    PostContentComponent.prototype.calculateStoryPreviewPosition = function (windowWidth, windowHeight) {
        var storyWidth = 320;
        var storyHeight;
        if (this.postContent.isVideo) {
            storyHeight = (this.postContent.mediaHeight / this.postContent.mediaWidth) * storyWidth;
        }
        else {
            storyHeight = (this.postContent.imageHeight / this.postContent.imageWidth) * storyWidth;
        }
        var storyTop = (windowHeight - storyHeight - 70) / 2;
        if (storyTop < 75) {
            storyHeight = windowHeight - 2 * 75 - 70;
            if (this.postContent.isVideo) {
                storyWidth = (this.postContent.mediaWidth / this.postContent.mediaHeight) * storyHeight;
            }
            else {
                storyWidth = (this.postContent.imageWidth / this.postContent.imageHeight) * storyHeight;
            }
            this.storyPreviewPopup.nativeElement.style.top = '75px';
        }
        else {
            this.storyPreviewPopup.nativeElement.style.top = storyTop + 'px';
        }
        this.storyPreviewPopup.nativeElement.style.width = storyWidth + 'px';
        this.storyPreviewPopup.nativeElement.style.height = storyHeight + 'px';
        this.storyPreviewPopup.nativeElement.style.left = "calc(50% - " + storyWidth / 2 + "px)";
    };
    PostContentComponent.prototype.onClickOutsideOverlay = function (evt) {
        this.closeStoryPreviewPopup();
    };
    PostContentComponent.prototype.closeStoryPreviewPopup = function () {
        if (!this.postContent.isVideo) {
            return;
        }
        if (this.storyPreviewPopup) {
            $('.overlay, .overlay-back').fadeOut(300);
            document.body.classList.remove('no-scroll');
            var videoPlayer = this.storyPreviewPopup.nativeElement.querySelector('video');
            // pause video when close popup
            if (videoPlayer) {
                videoPlayer.pause();
            }
        }
    };
    Object.defineProperty(PostContentComponent.prototype, "allowToAddNewMention", {
        get: function () {
            return this.showAddNewMention && !this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    PostContentComponent.prototype.onResize = function (event) {
        var _this = this;
        this.zone.runOutsideAngular(function () {
            _this.calculateStoryPreviewPosition(event.target.innerWidth, event.target.innerHeight);
        });
    };
    PostContentComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === PostContentComponent.COMPONENT_NAME && data.currentCounter === 1) {
                _this.pdfService.incrementNumberReportReady(PostContentComponent.COMPONENT_NAME);
            }
        });
    };
    PostContentComponent.COMPONENT_NAME = 'PostContentComponent';
    return PostContentComponent;
}());
export { PostContentComponent };



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-content/post-content.component.ts.pre-build-optimizer.js